import { createContext, useState, useCallback } from "react";
import { getPatientInfo } from "../../utils/services/Patients/getPatientInfo";
import { searchPatientsByName } from "../../utils/services/Patients/searchPatientsByName";
import { getPatientMembership } from "../../utils/services/Patients/getPatientMembership";
import { useValidToken } from "../../hooks/useValidToken";

export const PatientContext = createContext();

export const PatientProvider = ({ children }) => {
    const [patientDetails, setPatientDetails] = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const [memberships, setMemberships] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { isValid, authLoading } = useValidToken();

    const fetchPatientsMemberships = async (cipId) => {
        if (authLoading || !isValid) return;

        setLoading(true);
        setError(null);
        try {
            const data = await getPatientMembership(cipId);
            setMemberships(data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPatientsByName = async (name) => {
        if (!name || name.length < 3) {
            setSearchResults([]);
            return;
        }

        if (authLoading || !isValid) return;

        setLoading(true);
        setError(null);
        try {
            const data = await searchPatientsByName(name);
            setSearchResults(data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPatientDetails = useCallback(async (cipId) => {
        if (authLoading || !isValid) return null;

        setLoading(true);
        setError(null);
        try {
            const data = await getPatientInfo(cipId);
            setPatientDetails(data);
            return data;
        } catch (err) {
            setError(err);
            return null;
        } finally {
            setLoading(false);
        }
    }, [authLoading, isValid]);

    return (
        <PatientContext.Provider
            value={{
                patientDetails,
                searchResults,
                memberships,
                loading,
                error,
                fetchPatientsByName,
                fetchPatientDetails,
                fetchPatientsMemberships,
            }}
        >
            {children}
        </PatientContext.Provider>
    );
};

